import { IconButton, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/styles'
import React, { Suspense } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Spinner from '../components/Spinner'
import { Dispatch, GlobalState } from '../models/bootstrap'
import { Dialogs } from '../models/dialog'

const CreateProjectDialog = React.lazy(() => import('./CreateProjectDialog'))
const CreatePostDialog = React.lazy(() => import('./CreatePostDialog'))
const StartChatDialog = React.lazy(() => import('./StartChatDialog'))

const useStyles = makeStyles((theme) => ({
	dialogPaper: {
		minHeight: '50vh'
	}
}))

const KukidoDialog = () => {
	const classes = useStyles()
	const dispatch = useDispatch<Dispatch>()
	const { currentDialog, open } = useSelector((state: GlobalState) => ({
		currentDialog: state.dialog.currentDialog,
		open: state.dialog.open
	}))
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

	const handleClose = () => dispatch.dialog.closeDialog()

	const getDialogContent = (currentDialog: Dialogs | null) => {
		switch (currentDialog) {
			case Dialogs.createProject:
				return <CreateProjectDialog />
			case Dialogs.createPost:
				return <CreatePostDialog />
			case Dialogs.startChat:
				return <StartChatDialog />
			default:
				return (
					<>
						<IconButton edge='start' color='inherit' onClick={() => dispatch.dialog.closeDialog()} aria-label='close'>
							<CloseIcon />
						</IconButton>
						<Typography variant='body1'>"This is not the dialog you are looking for."</Typography>
					</>
				)
		}
	}

	return (
		<div>
			<Dialog
				open={open}
				onClose={handleClose}
				fullScreen={isMobile}
				fullWidth
				maxWidth='sm'
				disableEnforceFocus
				classes={{ paper: classes.dialogPaper }}>
				<Suspense fallback={<Spinner />}>{open && getDialogContent(currentDialog)}</Suspense>
			</Dialog>
		</div>
	)
}

export default KukidoDialog
